{
  "es": {
    "activity": {
      "attributes": {
        "end": "Fin",
        "now": "Ahora",
        "title": "Actividad reciente"
      },
      "labels": {
        "no_activities": "Aún no hay actividad",
        "no_activities_subtitle": "Cuando alguien cree una novedad, una decisión, una pregunta, etc., lo verás aquí.",
        "not_opened_yet": "Sin ver todavía"
      },
      "projects": {
        "announcement": {
          "create": "creó una novedad."
        },
        "building": {
          "create": "creó el edificio <i>'{notifiable_name}'</i>."
        },
        "document": {
          "create": "subió el documento <i>'{notifiable_name}'</i>."
        },
        "lot": {
          "create": "creó la parcela <i>'{notifiable_name}'</i>."
        },
        "phase": {
          "create": "creó la fase <i>'{notifiable_name}'</i>."
        },
        "published": {
          "customer": "ha publicado la decisión <i>'{notifiable_name}'</i> para el cliente.",
          "partners": "ha publicado la decisión <i>'{notifiable_name}'</i> para el/los colaborador(es)."
        },
        "question": {
          "create": "creó la pregunta <i>'{notifiable_name}'</i> en la FAQ <i>'{group_name}'</i>."
        },
        "space": {
          "create": "creó el anejo <i>'{notifiable_name}'</i>.",
          "update": "asignó el anejo <i>'{notifiable_name}'</i> a una unidad."
        },
        "survey_type": {
          "create": "creó una encuesta de tipo <i>'{notifiable_name}'</i>."
        },
        "ticket": {
          "create": "inició la conversación <i>'{notifiable_name}'</i>."
        },
        "unit": {
          "assign": "asignó <i>'{notifiable_name}'</i> a un cliente.",
          "create": "creó la unidad <i>'{notifiable_name}'</i>.",
          "invisibled": "revocó el acceso del cliente a <i>'{notifiable_name}'</i>.",
          "unassign": "desasignó <i>'{notifiable_name}'</i> del cliente.",
          "visibled": "dio acceso al cliente a <i>'{notifiable_name}'</i>."
        }
      },
      "units": {
        "announcement": {
          "create": "creó una novedad."
        },
        "decision": {
          "create": "creó la decisión <i>'{notifiable_name}'</i>.",
          "not_interested": "no muestra interés en la decisión <i>'{notifiable_name}'</i>.",
          "published": {
            "customer": "ha publicado la decisión <i>'{notifiable_name}'</i> para el cliente.",
            "partners": "ha publicado la decisión <i>'{notifiable_name}'</i> para el/los colaborador(es)."
          },
          "relaunched": "volvió a poner disponible la decisión <i>'{notifiable_name}'</i>."
        },
        "decision_document": {
          "create": "subió el documento <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "aprobó la propuesta <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>.",
          "create": {
            "customer": "compartió la propuesta <i>'{notifiable_name}'</i> con el cliente.",
            "employee": "creó la propuesta <i>'{notifiable_name}'</i>.",
            "partnergroup": "compartió la propuesta <i>'{notifiable_name}'</i> con el colaborador <i>{target_name}</i>."
          },
          "unapproved": "retiró la aprobación de la propuesta <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>.",
          "updated": "actualizó la propuesta <i>'{notifiable_name}'</i> en la decisión <i>'{group_name}'</i>."
        },
        "document": {
          "create": "subió el documento <i>'{notifiable_name}'</i>.",
          "destroy": "eliminó el documento <i>'{notifiable_name}'</i>"
        },
        "issue": {
          "approval": {
            "create": "solicitó la aprobación del cliente.",
            "delete": "eliminó la solicitud de aprobación del cliente.",
            "rejected": "rechazó esta incidencia."
          },
          "approved": "aprobó esta incidencia",
          "create": "creó esta incidencia",
          "status": {
            "update": "ha cambiado el estado de la incidencia <i>'{notifiable_name}'</i> a <i>{target_name}</i>."
          }
        },
        "proposal": {
          "deleted": "eliminó la propuesta <i>'{notifiable_name}'</i>."
        },
        "question": {
          "create": "creó la pregunta <i>'{notifiable_name}'</i> en la FAQ <i>'{group_name}'</i>."
        },
        "space": {
          "update": "asignó el anejo <i>'{notifiable_name}'</i> a esta unidad."
        },
        "survey": {
          "create": "creó la encuesta <i>'{notifiable_name}'</i>.",
          "published": "publicó la encuesta <i>'{notifiable_name}'</i>."
        },
        "ticket": {
          "create": "inició la conversación <i>'{notifiable_name}'</i>.",
          "message": {
            "move": "movió un mensaje a la conversación <i>'{notifiable_name}'</i>."
          }
        },
        "unit": {
          "assign": "asignó <i>'{notifiable_name}'</i> a un cliente.",
          "invisibled": "revocó el acceso del cliente a <i>'{notifiable_name}'</i>.",
          "unassign": "desasignó <i>'{notifiable_name}'</i> del cliente.",
          "visibled": "dio acceso al cliente a <i>'{notifiable_name}'</i>."
        }
      }
    }
  }
}
